<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <CalendarIcon />
      <h2 class="text-lg font-medium mr-auto">{{ $t('reservation.list') }}</h2>
    </div>
    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-5">
      <EmployeeCalendar />
    </div>
    <!-- END: HTML Table Data -->
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import EmployeeCalendar from '../../components/reservations/EmployeeCalendar.vue'

export default defineComponent({
  components: {
    EmployeeCalendar
  },
  computed: {
    console: () => console
  },
  methods: {},
  setup() {
    return {}
  }
})
</script>
